module.exports = __webpack_public_path__ + "img/table-icon.52978915.svg";